import React from 'react';
import NotAvailablePage from './NotAvailablePage';

function ErrorBoundary({fallback, children}) {
  return (
    <ErrorBoundaryInner fallback={fallback}>{children}</ErrorBoundaryInner>
  );
}

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false, error: null};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error};
  }

  componentDidCatch(error, errorInfo) {
    console.error('Caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <NotAvailablePage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
